var map = {
	"./audio/0001.mp3": "+L22",
	"./audio/0002.mp3": "dkBL",
	"./audio/0003.mp3": "7FH+",
	"./audio/0004.mp3": "hKZm",
	"./audio/0005.mp3": "lXDH",
	"./audio/0006.mp3": "dhWo",
	"./audio/0007.mp3": "JQWw",
	"./audio/0008.mp3": "a13A",
	"./audio/0009.mp3": "q9PF",
	"./audio/0010.mp3": "zFaL",
	"./audio/0011.mp3": "vY+g",
	"./audio/0012.mp3": "DV8Y",
	"./audio/0013.mp3": "IV7v"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "194M";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/audio.*$
// module id = 194M
// module chunks = 0